import { render, staticRenderFns } from "./EditDressModal.vue?vue&type=template&id=6c8899ba&scoped=true"
import script from "./EditDressModal.vue?vue&type=script&lang=js"
export * from "./EditDressModal.vue?vue&type=script&lang=js"
import style0 from "./EditDressModal.vue?vue&type=style&index=0&id=6c8899ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8899ba",
  null
  
)

export default component.exports